export default __webpack_public_path__ + "static/media/speer_logo_mobile.ef94ba80.svg";